/**
 * PATH: packages/ui/src/kanban/api/contract-placement.ts
 * FILE_ID: UI-KANBAN-API-PLACEMENT-001
 * PURPOSE: Typed runtime contract for exact card placement verbs.
 * WHY: Move, Also show and Copy as new must remain distinct persisted effects.
 */
import type { CardLanePlacement } from '../types'

export type PlacementVerbV1 = 'move' | 'also_show' | 'copy_as_new'
export type PlacementEffectKindV1 =
  | 'moves_existing_presence'
  | 'adds_same_card_presence'
  | 'creates_linked_card'

export interface PlacementIntentV1 {
  schema_version: 'email-placement.v1'
  verb: PlacementVerbV1
  expected_effect: PlacementEffectKindV1
  source_card_id: string
  source_lane_id?: string | null
  target_board_id: string
  target_lane_id?: string
  idempotency_key: string
  preserve_source_presence: boolean
}

export interface PlacementEffectV1 {
  verb: PlacementVerbV1
  card_id: string
  placement_id?: string | null
  target_board_id: string
  target_lane_id: string
  created: boolean
  undo_context: Record<string, unknown>
}

export interface KanbanPlacementApi {
  executePlacementVerb?(
    cardId: string,
    intent: PlacementIntentV1,
  ): Promise<PlacementEffectV1>
  addCardPlacement?(
    cardId: string,
    body: { lane_id: string } | { board_id: string },
  ): Promise<CardLanePlacement>
  updateCardPlacement?(
    cardId: string,
    placementId: string,
    body: { lane_id?: string; position?: number },
  ): Promise<CardLanePlacement>
  removeCardPlacement?(cardId: string, placementId: string): Promise<void>
}

export const PLACEMENT_EFFECTS: Readonly<
  Record<PlacementVerbV1, PlacementEffectKindV1>
> = {
  move: 'moves_existing_presence',
  also_show: 'adds_same_card_presence',
  copy_as_new: 'creates_linked_card',
}
